var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import MappableTraits from "./MappableTraits";
import ImageryProviderTraits from "./ImageryProviderTraits";
let MapboxStyleCatalogItemTraits = (_dec = primitiveTrait({
  name: "url",
  description: "The Mapbox server url.",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "accessToken",
  description: "The username of the map account.",
  type: "string"
}), _dec3 = primitiveTrait({
  name: "styleId",
  description: "The Mapbox Style ID. eg 'streets-v11', 'outdoors-v11'. You can find more styleIds for the 'mapbox' user here: https://docs.mapbox.com/api/maps/styles/#mapbox-styles",
  type: "string"
}), _dec4 = primitiveTrait({
  name: "accessToken",
  description: "The public access token for the imagery.",
  type: "string"
}), _dec5 = primitiveTrait({
  name: "tilesize",
  description: "The size of the image tiles.",
  type: "number"
}), _dec6 = primitiveTrait({
  name: "scaleFactor",
  description: "When true, the tiles are rendered at a @2x scale factor.",
  type: "boolean"
}), _class = class MapboxStyleCatalogItemTraits extends mixTraits(ImageryProviderTraits, CatalogMemberTraits, MappableTraits, LegendOwnerTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "url", _descriptor, this);
    _initializerDefineProperty(this, "username", _descriptor2, this);
    _initializerDefineProperty(this, "styleId", _descriptor3, this);
    _initializerDefineProperty(this, "accessToken", _descriptor4, this);
    _initializerDefineProperty(this, "tilesize", _descriptor5, this);
    _initializerDefineProperty(this, "scaleFactor", _descriptor6, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "url", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "https://api.mapbox.com/styles/v1/";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "username", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "mapbox";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "styleId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "accessToken", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "tilesize", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 512;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "scaleFactor", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { MapboxStyleCatalogItemTraits as default };